import { useAppDispatch } from "@/services/store";
import type { UseFilters } from "@/features/notes-manager";
import type { MenuSorterOptions } from "@/common/AppHeader/mobile/Components/Menu/MenuSorterList";
import { ideasPageActions } from "../slice";

export const useFilters = (): UseFilters => {
  const dispatch = useAppDispatch();

  const setSorter = (sort: MenuSorterOptions) => {
    dispatch(ideasPageActions.setSorter(sort));
  };

  const setTitleFilter = (value: string) => {
    dispatch(ideasPageActions.setTitleFilter(value));
  };

  const setNoteTitleFilter = (value: string) => {
    dispatch(ideasPageActions.setNoteTitleFilter(value));
  };

  const setFromDateFilter = (value: string) => {
    dispatch(ideasPageActions.setFromDateFilter(value));
  };

  const setToDateFilter = (value: string) => {
    dispatch(ideasPageActions.setToDateFilter(value));
  };

  const setPersonGroupFilters = (value: string[]) => {
    dispatch(ideasPageActions.setPersonGroupFilters(value));
  };

  const setNoteTypeFilters = (value: string[]) => {
    dispatch(ideasPageActions.setNoteTypeFilters(value));
  };

  const setStringFilter = (value: string) => {
    dispatch(ideasPageActions.setStringFilter(value));
  };

  const setStatusFilters = (value: string[]) => {
    dispatch(ideasPageActions.setStatusFilter(value));
  };

  return {
    setSorter,
    setTitleFilter,
    setNoteTitleFilter,
    setFromDateFilter,
    setToDateFilter,
    setPersonGroupFilters,
    setNoteTypeFilters,
    setStringFilter,
    setStatusFilters,
  };
};
